<div class="d-flex flex-auto flex-column" *ngIf="canShowChart">
  <div class="item line-item d-flex flex-column" *ngFor="let item of series; let i = index;">
    <div class="d-flex flex-row mention-box">
      <div *ngIf="showIndex" class="index">{{i + 1 + startIndex}}.</div>
      <div class="ellipsis mention {{chartTitleClasses}}">{{item.title}}</div>
      <div class="d-flex justify-content-end number">{{item.formattedValue}}</div>
    </div>
    <div class="d-flex flex-row mention-percent align-items-center" *ngIf="!isLeftSide">
      <div class="d-flex progress-bar-container right bar-container">
        <div class="progress-bar"
             [style.width.%]="calculateProgressBar(item.value)"
             [style.backgroundColor]="chartColor"
             [style.height.px]="progressHeight"
             [style.borderRadius.px]="borderRadius">
        </div>
      </div>
    </div>
    <div class="d-flex flex-row mention-percent align-items-center" *ngIf="isLeftSide">
      <div class="d-flex progress-bar-container left bar-container">
        <div class="progress-bar" [style.height.px]="progressHeight"
             [style.borderRadius.px]="borderRadius"
             [style.width.%]="calculateProgressBar(item.value)"
             [style.backgroundColor]="chartColor"></div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/new-influencer-demographic/demographic-bar-chart/demographic-bar-chart.component.html